// extracted by mini-css-extract-plugin
export default {"input":"ManualEntryModal_input__G+SkO","menu_item":"ManualEntryModal_menu_item__ourBB","submission_input_error":"ManualEntryModal_submission_input_error__MHmfa"};